// extracted by mini-css-extract-plugin
module.exports = {"agentDetailsModalContent":"RtdWindow_agentDetailsModalContent__1YoVN","userDetails":"RtdWindow_userDetails__1rpk_","userDetailsFlex":"RtdWindow_userDetailsFlex__1b3Bp"};